{
  "resetAbortMessage": "Нет",
  "resetConfirmMessage": "Да, начать сначала",
  "resetQuestionDescription": "Код вернется в исходное состояние, а все изменения будут отменены.",
  "resetQuestionMessage": "Вы действительно хотите начать сначала?"
}
